import { Box, Grid, Heading, Text } from "@chakra-ui/react";
import { Reveal, RichText } from "@/components";
import { CLAIMS, CLAIMS_LABEL } from "@/content";

export const Claims = () => (
  <Box as="section" aria-label={CLAIMS_LABEL} maxW="maxw" mx="auto" px="pad" pb="sec">
    <Reveal>
      <Grid
        as="ul"
        role="list"
        gap="1px"
        bg="line.hairline"
        borderTop="1px solid"
        borderBottom="1px solid"
        borderColor="line.hairline"
        templateColumns={{ base: "1fr", sm: "repeat(2, 1fr)", "2xl": "repeat(4, 1fr)" }}
      >
        {CLAIMS.map((claim) => (
          <Grid
            as="li"
            key={claim.id}
            bg="surface.DEFAULT"
            px="clamp(16px, 2vw, 28px)"
            py="clamp(24px, 3vw, 40px)"
            gap="12px"
            alignContent="start"
          >
            <Box
              aria-hidden="true"
              w="32px"
              h="32px"
              mb="10px"
              bg="brand.500"
              sx={{
                WebkitMask: `${claim.icon} center / ${claim.iconSize ?? "contain"} no-repeat`,
                mask: `${claim.icon} center / ${claim.iconSize ?? "contain"} no-repeat`,
                "@supports not ((-webkit-mask: none) or (mask: none))": {
                  width: "26px",
                  height: "2px",
                  marginBottom: "4px",
                },
              }}
            />
            <Heading as="h2" variant="card" minBlockSize={{ sm: "1.9em" }}>
              <RichText nodes={claim.title} />
            </Heading>
            <Text variant="body" fontSize="small" lineHeight={1.4}>
              {claim.note}
            </Text>
          </Grid>
        ))}
      </Grid>
    </Reveal>
  </Box>
);
